<template>
    <div class="credit_page">
        <div class="container">
            <h2>Team Uniform Page</h2>
        </div>
    </div>
</template>
<script>
export default {
    name: "BusinessCreditApp",
    mounted() {
        /* eslint-disable */
        $(document).ready(function () {
            var navListItems = $("div.setup-panel div a");
            var mainparent = $("div.setup-panel div"),
                allWells = $(".setup-content"),
                allNextBtn = $(".nextBtn"),
                allPrevBtn = $(".prevBtn");

            allWells.hide();

            navListItems.click(function (e) {
                e.preventDefault();
                var $target = $($(this).attr("href")),
                    $item = $(this);

                if (!$item.hasClass("disabled")) {
                    navListItems
                        .removeClass("btn-primary")
                        .addClass("btn-default");
                    $item.addClass("btn-primary");
                    $item.parent().prev().children("a").addClass("btn_submit");
                    $item.removeClass("btn_submit");
                    $item.parent().next().removeClass("select-active");
                    $item.parent().addClass("select-active");
                    allWells.hide();
                    $target.show();
                    $target.find("input:eq(0)").focus();
                }
            });

            allPrevBtn.click(function () {
                var curStep = $(this).closest(".setup-content"),
                    curStepBtn = curStep.attr("id"),
                    prevStepWizard = $(
                        'div.setup-panel div a[href="#' + curStepBtn + '"]'
                    )
                        .parent()
                        .prev()
                        .children("a");
                prevStepWizard.removeAttr("disabled").trigger("click");
            });

            allNextBtn.click(function () {
                var curStep = $(this).closest(".setup-content"),
                    curStepBtn = curStep.attr("id"),
                    nextStepWizard = $(
                        'div.setup-panel div a[href="#' + curStepBtn + '"]'
                    )
                        .parent()
                        .next()
                        .children("a"),
                    curInputs = curStep.find(
                        "input[type='text'],input[type='url']"
                    ),
                    isValid = true;

                $(".form-group").removeClass("has-error");
                for (var i = 0; i < curInputs.length; i++) {
                    if (!curInputs[i].validity.valid) {
                        isValid = false;
                        $(curInputs[i])
                            .closest(".form-group")
                            .addClass("has-error");
                    }
                }
                nextStepWizard.removeAttr("disabled").trigger("click");
            });

            $("div.setup-panel div a.btn-primary").trigger("click");
        });
        /* eslint-enable */
    }
};
</script>
